// 重要提示：该文件中部分"导入但未使用"的变量，是用于动态组件渲染的eval()操作，请勿删除

// 将大型元素组件字典改为动态导入以优化构建内存使用
// import elementComponentDict from '@/mock/element-component-dict.json'  // 移除静态导入
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'

const ELEMENT_PAGE_TYPE_MAP = new Map([
  [UICustomConstants.SEA_BOOKING_BASIC.toString(), () => import('@/config/uiCustom/se/tabBookingFCL.json')],
  [UICustomConstants.SEA_BOOKING_VESSEL.toString(), () => import('@/config/uiCustom/se/tabVesselEq.json')],
  [UICustomConstants.SEA_BOOKING_MBL.toString(), () => import('@/config/uiCustom/se/tabMBL.json')],
  [UICustomConstants.SEA_BOOKING_HBL.toString(), () => import('@/config/uiCustom/se/tabHBL.json')],
  [UICustomConstants.SEA_BOOKING_VIRTUAL_HBL.toString(), () => import('@/config/uiCustom/se/tabHBL2.json')],
  [UICustomConstants.AIR_BOOKING_BASIC.toString(), () => import('@/config/uiCustom/ae/tabGeneral.json')],
  [UICustomConstants.AIR_BOOKING_VESSEL.toString(), () => import('@/config/uiCustom/ae/tabVesselEq.json')]
])
let elementComponentDict = null // 延迟加载的字典缓存

/**
 * 动态加载元素组件字典
 * 优化构建内存使用，避免大型JSON文件在构建时占用过多内存
 */
export async function loadElementComponentDict() {
  if (!elementComponentDict) {
    try {
      elementComponentDict = {}
      for (const [pageType, importFunc] of ELEMENT_PAGE_TYPE_MAP.entries()) {
        const module = await importFunc()
        elementComponentDict[pageType] = module.default || module
      }
      console.log('[组件字典] 动态加载完成，字典大小:', Object.keys(elementComponentDict).length)
    } catch (error) {
      console.error('[组件字典] 动态加载失败:', error)
      elementComponentDict = {} // 使用空字典作为兜底
    }
  }
  return elementComponentDict
}

import { BL_MODES } from '@/class/cargo/model/parameters/BlMode'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import { CONTAINERLOAD_TYPES } from '@/class/cargo/model/parameters/ContainerLoadType'
import {
  EXPRESS_COMPANYS,
  ORDER_DESTINATION_DISTRIBUTION_TYPES
} from '@/class/cargo/model/parameters/FbaJobConstants'
import { PRINT_PARAM4_TYPES } from '@/class/cargo/model/parameters/PrintParam4'
import { PRINT_PARAM5_TYPES } from '@/class/cargo/model/parameters/PrintParam5'
import { BOOKING_TERMS, FNL_TM } from '@/class/cargo/model/parameters/SeaExportConstants'
import { CARGO_SOURCES } from '@/class/cargo/model/parameters/SystemConstants'
import { WAREHOUSE_STATE } from '@/class/cargo/model/parameters/WarehouseInState'
import { VIRTUAL_BILL_TYPES } from '@/class/cargo/model/parameters/VirtualBillType'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import uiCustomPathComponenMap from '@/components/uiCustom/pathComponenMap'
import store from '@/store'

/**
 * 注意：
 * 此处采用的是动态导入的方式，可以避免组件过早创建而因为属性缺失导致报错。
 * 这个方式已经验证，确实是动态调用，不会在加载element-registry时就导入所有组件。
 */

// 组件路径映射表
const componentPathMap = {
  ...uiCustomPathComponenMap,
  '@/components/Cargo/Common/cargoAdvanceSelect': () => import('@/components/standard/cargoAdvanceSelect'),
  '@/components/Cargo/Common/cargoCompanySelect': () => import('@/components/standard/cargoCompanySelect'),
  '@/components/Cargo/Common/cargoUserSelect': () => import('@/components/standard/cargoUserSelect'),
  '@/components/Cargo/Common/cargoOfficeSelect': () => import('@/components/standard/cargoOfficeSelect'),
  '@/components/Cargo/Common/cargoDepartmentSelect': () => import('@/components/standard/cargoDepartmentSelect'),
  '@/components/Cargo/Common/cargoDepartmentNewSelect': () => import('@/components/standard/cargoDepartmentNewSelect'),
  '@/components/Cargo/Common/cargoRichTextarea': () => import('@/components/Cargo/Common/cargoRichTextarea'),
  '@/components/Cargo/Common/AutoNumberInput': () => import('@/components/Cargo/Common/AutoNumberInput'),
  '@/components/Cargo/Common/cargoRepeatValueSelect': () => import('@/components/Cargo/Common/cargoRepeatValueSelect'),
  '@/components/Cargo/Common/cargoAgGrid': () => import('@/components/Cargo/Common/cargoAgGrid'),
  '@/components/Cargo/Common/cargoPackingSelect': () => import('@/components/standard/cargoPackingSelect'),
  '@/components/Cargo/Common/cargoSalesCompanySelect': () => import('@/components/Cargo/Common/cargoSalesCompanySelect'),
  '@/components/Cargo/Common/cargoMultiSelect': () => import('@/components/Cargo/Common/cargoMultiSelect'),
  '@/components/Cargo/Job/soNoInput': () => import('@/components/Cargo/Job/soNoInput'),
  '@/components/Cargo/Common/cargoInput': () => import('@/components/Cargo/Common/cargoInput')
}

// 以下导入参数请勿删除，会用于动态js代码的执行

// 动态内容开始

const $store = store
const blModes = BL_MODES
const billTypes = BILL_TYPES
const containerLoadTypes = CONTAINERLOAD_TYPES
const expressCompanys = EXPRESS_COMPANYS
const orderDestinationDistributionTypes = ORDER_DESTINATION_DISTRIBUTION_TYPES
const fnlTm = FNL_TM
const cargoSources = CARGO_SOURCES
const warehouseState = WAREHOUSE_STATE
const printParam4Types = PRINT_PARAM4_TYPES
const printParam5Types = PRINT_PARAM5_TYPES
const bookingTerms = BOOKING_TERMS
const selectTypeNames = TYPE_NAMES
const virtualBillTypes = VIRTUAL_BILL_TYPES

// 动态内容结束

// TODO: 需要跳过的属性列表，这些属性处理暂时有问题
const SKIP_PROPS = ['staticOptions', 'dataFilterFunction']
// 对象属性列表
const OBJECT_PROPS = ['methodParams', 'job']

export function getElementComponentInfo(element) {
  if (!element) {
    return null
  }

  const moduleDict = elementComponentDict
  if (!moduleDict) {
    console.warn(`[组件容器] 类型 ${element.pageType} 的页签不存在`)
    return null
  }

  return moduleDict[String(element.pageType)]?.[element.elementName]
}

/**
 * 获取元素对应的组件
 * @param {Object} element - 元素对象
 * @returns {Promise<Component>} 元素组件
 */
export async function getElementComponent(element) {
  console.log('getElementComponent', element)
  if (!element) {
    return 'el-input' // 默认使用 el-input
  }

  // 从元素组件字典中获取组件信息
  const moduleDict = elementComponentDict
  if (!moduleDict) {
    console.warn(`[组件容器] 类型 ${element.pageType} 的页签不存在`)
    return 'el-input' // 如果找不到对应的模块，使用默认的 el-input
  }

  const componentInfo = moduleDict[String(element.pageType)]?.[element.elementName]
  if (!componentInfo) {
    console.warn(`[组件容器] 元素 ${element.elementName} 在类型 ${element.pageType} 的页签中不存在`)
    return 'el-input' // 如果找不到对应的组件信息，使用默认的 el-input
  }

  const { elementComponentType, elementComponentPath } = componentInfo

  // 如果是 Element UI 的组件，直接返回组件名
  if (elementComponentType.startsWith('el-')) {
    return elementComponentType
  }

  // 如果是自定义组件，从映射表中获取
  if (elementComponentPath) {
    const componentLoader = componentPathMap[elementComponentPath]
    if (componentLoader) {
      try {
        // 检查是否为函数（动态导入）或已经是组件对象
        const component = typeof componentLoader === 'function'
          ? (await componentLoader())?.default
          : componentLoader
        return component
      } catch (error) {
        console.error(`[组件容器] 组件加载失败: ${elementComponentPath}`, error)
        return 'el-input'
      }
    }
    if (elementComponentPath && !componentLoader) {
      console.error(`[组件容器] 组件未注册: ${elementComponentPath}`)
    }
  }

  return 'el-input' // 兜底使用 el-input
}

/**
 * 获取元素组件的属性
 * @param {Object} element - 元素对象
 * @param {Object} job - 表单对象
 * @returns {Object} 元素组件属性
 */
export function getElementProps(element, job) {
  if (!element) {
    return {
      type: 'text',
      clearable: true
    }
  }

  const moduleDict = elementComponentDict
  if (!moduleDict) {
    console.warn(`[组件容器] 类型 ${element.pageType} 的页签不存在`)
    return {
      type: 'text',
      clearable: true
    }
  }

  const componentInfo = moduleDict[String(element.pageType)]?.[element.elementName]
  if (!componentInfo) {
    console.warn(`[组件容器] 元素 ${element.elementName} 在类型 ${element.pageType} 的页签中不存在`)
    return {
      type: 'text',
      clearable: true
    }
  }

  // 获取当前是否为中文
  const isZh = getIsZh()

  // 处理需要求值的属性
  const props = {}
  Object.entries(componentInfo.elementProps || {}).forEach(([prop, value]) => {
    // 跳过特定属性
    if (SKIP_PROPS.includes(prop)) {
      return
    }

    // 记录是否带:前缀
    const hasColonPrefix = prop.startsWith(':')
    // 处理带:前缀的属性，移除:前缀
    const propName = hasColonPrefix ? prop.substring(1) : prop

    // 处理对象类型属性
    if (OBJECT_PROPS.includes(propName)) {
      try {
        props[propName] = eval(`(${value})`)
      } catch (error) {
        console.warn(`[组件容器] 组件 ${componentInfo.elementComponentType} 属性 ${propName} 对象解析失败:`, error)
        props[propName] = value
      }
      return
    }

    // 处理需要求值的属性（包括带:前缀的属性）
    if (hasColonPrefix) {
      try {
        props[propName] = eval(value)
      } catch (error) {
        console.warn(`[组件容器] 组件 ${componentInfo.elementComponentType} 属性 ${propName} 求值失败:`, error)
        props[propName] = value
      }
    } else {
      props[propName] = value
    }
  })
  return props
}

/**
 * 判断是否为选择类型组件
 * @param {string|Object} component - 组件对象或组件名称
 * @returns {boolean} 是否为选择类型组件
 *
 * 判断组件是否为选择类型（el-select 或 cargo-multi-select）
 * 这些组件需要动态渲染 el-option 子组件
 */
export function isSelectType(component) {
  if (!component) return false
  const componentName = typeof component === 'string' ? component : component.name
  return ['el-select', 'CargoMultiSelect'].includes(componentName)
}

/**
 * 获取选择组件的选项
 * @param {Object} element - 元素对象
 * @param {Object} job - 表单对象
 * @returns {Array} 选项数组
 *
 * 从 element-component-dict.json 中获取选项数据
 * 通过 eval 求值 options 字符串，获取实际的选项数组
 */
export function getElementSelectOptions(element) {
  if (!element) return []

  // 从元素组件字典中获取组件信息
  const moduleDict = elementComponentDict
  if (!moduleDict) {
    console.warn(`[组件容器] 类型 ${element.pageType} 的页签不存在`)
    return []
  }

  const componentInfo = moduleDict[String(element.pageType)]?.[element.elementName]
  if (!componentInfo?.elementSelectOptions?.options) {
    console.warn(`[组件容器] 元素 ${element.elementName} 在类型 ${element.pageType} 的页签中没有选项配置`)
    return []
  }

  try {
    return eval(componentInfo.elementSelectOptions.options) || []
  } catch (error) {
    console.warn(`[组件容器] 选项数据求值失败: element=${element.elementName}, options=${componentInfo.elementSelectOptions.options}, error=${error.message}`)
    return []
  }
}

/**
 * 获取选项的属性值
 * @param {Object} item - 选项对象
 * @param {number} index - 选项索引
 * @param {Object} element - 元素对象
 * @param {string} propName - 属性名 (label/value/key)
 * @returns {string|number|null} 选项的属性值
 *
 * 根据 element-component-dict.json 中的配置获取选项的属性值
 * 支持动态表达式，通过 eval 求值
 * 如果求值失败或配置不存在，返回 null
 */
export function getOptionProp(item, index, element, propName) {
  if (!element) return null

  // 从元素组件字典中获取组件信息
  const moduleDict = elementComponentDict
  if (!moduleDict) {
    console.warn(`[组件容器] 类型 ${element.pageType} 的页签不存在`)
    return null
  }

  const componentInfo = moduleDict[String(element.pageType)]?.[element.elementName]
  if (!componentInfo?.elementSelectOptions || !componentInfo.elementSelectOptions[propName]) {
    console.warn(`[组件容器] 元素 ${element.elementName} 在类型 ${element.pageType} 的页签中没有${propName}配置`)
    return null
  }

  try {
    const isZh = getIsZh()
    return eval(componentInfo.elementSelectOptions[propName])
  } catch (error) {
    console.warn(`[组件容器] 选项${propName}求值失败: element=${element.elementName}, ${propName}=${componentInfo.elementSelectOptions[propName]}, error=${error.message}`)
    return null
  }
}

/**
 * 获取当前是否为中文
 * @returns {boolean} 是否为中文
 */
export function getIsZh() {
  return store.getters.language === 'zh'
}
